import React from 'react';
import { RouteType, userRoutes } from '../../../routes/routes';
import { generatePath, useHistory, useLocation, useParams } from 'react-router';
import { FormattedMessage } from 'react-intl';

interface LocationState {
  fromApp?: boolean;
}

const GoBackButton: React.FC<{ backRoute?: RouteType }> = ({ backRoute }) => {
  let backPath: string | undefined;
  const history = useHistory();
  const location = useLocation<LocationState>();
  const params = useParams();

  if (backRoute?.back) {
    const key = backRoute.back as unknown as string;
    backPath = userRoutes[key].path;
  }

  if (!backPath) return null;

  const goBack = () => {
    if (backPath) {
      const hasPreviousEntry = location.state?.fromApp;

      if (hasPreviousEntry) {
        history.goBack();
      } else {
        history.push(generatePath(backPath, params), { fromApp: location.state?.fromApp });
      }
    }
  };

  return (
    <div
      className="back-button d-flex align-items-center"
      onClick={goBack}
      style={{ cursor: backPath ? 'pointer' : 'default' }}
    >
      <span className="mdi mdi-chevron-left"></span> <FormattedMessage id={'back'}></FormattedMessage>
    </div>
  );
};

export default GoBackButton;
